import React, { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'

const LoginModal = ({ onClose }) => {
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { login } = useAuth()

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => document.body.classList.remove('modal-open')
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    
    if (!name.trim() || !password) {
      setError('Please enter both username and password.')
      return
    }

    setLoading(true)
    const result = await login({ name: name.trim(), password })
    
    if (result.success) {
      onClose()
    } else {
      setError(result.error)
    }
    setLoading(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e)
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal login-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Welcome Back</h2>
          <button 
            className="btn ghost sm" 
            onClick={onClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>
        
        <div className="modal-content">
          <div className="login-intro">
            <p className="muted">
              Sign in to access your personal dashboard and track your progress.
            </p>
            <div className="admin-hint">
              <span className="chip">Admin Access</span>
              <span className="muted">Use "Admin" as username</span>
            </div>
          </div>
          
          {error && (
            <div className="error-message">
              <span>⚠</span>
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="login-name">Username</label>
              <input 
                id="login-name"
                autoFocus 
                placeholder="Enter your name or 'Admin'" 
                value={name} 
                onChange={e => setName(e.target.value)}
                disabled={loading}
                className="form-input"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="login-password">Password</label>
              <input 
                id="login-password"
                type="password" 
                placeholder="Enter your password" 
                value={password} 
                onChange={e => setPassword(e.target.value)}
                disabled={loading}
                className="form-input"
              />
            </div>
            
            <div className="form-actions">
              <button 
                type="submit" 
                className="btn primary full-width"
                disabled={loading || !name.trim() || !password}
              >
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Signing In...
                  </>
                ) : (
                  'Sign In'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginModal
